const FromArr = [
  {
    title: "",
    modelvalue: "",
    inputtype: "select",
    inputflag: true,
    fontSize: 14,
    color: "#424E66",
    lableheight: 20,
    types: "text",
    placeholder: "发布人",
    width: 234,
    height: 32,
    disabled: false,
    marginLeft: 25,
    marginTop: 35,
    X: false,
    options: [],
  },
  {
    title: "",
    inputtype: "dateSection",
    inputflag: true,
    fontSize: 14,
    color: "#424E66",
    lableheight: 20,
    X: false,
    types: "date",
    placeholder: "发布时间",
    width: 234,
    disabled: false,
    heightLeft: 32,
    heightRight: 32,
    marginLeft: 25,
    marginTop: 35,
    StartTime: "",
    EndTime: "",
  },
];
export default FromArr;
